export default "__VITE_ASSET__BpIkxTdA__"